import PropTypes from "prop-types";

export const subscriptionUserAssignmentShape = {
  ref: PropTypes.string.isRequired,
  customName: PropTypes.string,
  phoneNumber: PropTypes.string,
  status: PropTypes.string.isRequired,
  maxActiveVehicles: PropTypes.number.isRequired
};
